<template>
	<div class="m-portlet_ m-portlet--brand m-portlet--head-solid-bg m-portlet--bordered">
		<div class="m-portlet__head">
			<div class="m-portlet__head-caption">
				<div class="m-portlet__head-title">
					<h3 class="m-portlet__head-text">
						{{ this.title }}
					</h3>
				</div>
			</div>
		</div>
		<div class="m-portlet__body">
			<!--begin::Section-->
			<div class="m-section">
				<div class="m-section__content">
					<table class="table m-table m-table--head-separator-primary table-striped">
						<thead>
							<tr>
								<th>#</th>
								<th>Loại</th>
								<th>Tiền cò</th>
								<th>Hạn mức ngày</th>
								<th>Trả thưởng</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(row, index) in this.data">
								<th scope="row">{{index+1}}</th>
								<td>{{row.prop}}</td>
								<td>{{row.commission}}</td>
								<td>{{row.limit_day}}</td>
								<td>{{row.rate}}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<!--end::Section-->
		</div>
	</div>
</template>

<script>
	export default {
		props: ['title', 'data']
	}

</script>